module.exports = __webpack_public_path__ + "static/personal-776b4b1c95b549a327c609fab84e905d.png";